import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiUrlEnum } from 'src/config/endPointsConfig';
import { editEffect, editImpact, editMetric, editProduct } from '../services/impact.service';

export const useEditMetric = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: {
      id: string;
      nb?: string;
      nbV?: string;
      title?: string;
      titleV?: string;
      ciblep?: string;
      snte?: string;
      voletv?: string;
      voletp?: string;
      contribSnte?: string;
      contribSntev?: string;
      startv?: string;
      ciblev?: string;
      nbExtra?: string;
      nbExtraV?: string;
      indicProgV?: string;
      indicProg?: string;
      sourceV?: string;
      source?: string;
      values?: { key: string; value: string }[];
    }) => editMetric(body),
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: [ApiUrlEnum.impact],
      });
    },
  });
};

export const useEditImpact = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: { id: string; comment: string }) => editImpact(body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ApiUrlEnum.impact],
      });
    },
  });
};

export const useEditProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: { id: string; comment: string }) => editProduct(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ApiUrlEnum.impact] });
    },
  });
};

export const useEditEffect = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: { id: string; comment: string }) => editEffect(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ApiUrlEnum.impact] });
    },
  });
};
